/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Collaborators_Manageroles_Edittitle2Inputs */

const en_settings_collaborators_manageroles_edittitle2 = /** @type {(inputs: Settings_Collaborators_Manageroles_Edittitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit assignments`)
};

/**
* | output |
* | --- |
* | "Edit assignments" |
*
* @param {Settings_Collaborators_Manageroles_Edittitle2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_collaborators_manageroles_edittitle2 = /** @type {((inputs?: Settings_Collaborators_Manageroles_Edittitle2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Collaborators_Manageroles_Edittitle2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_collaborators_manageroles_edittitle2(inputs)
});
export { settings_collaborators_manageroles_edittitle2 as "settings_collaborators_manageRoles_editTitle" }